import * as React from 'react';
import { useState} from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Row, Col, Input, Label, Button, CardBody, FormFeedback, CardTitle, Card } from 'reactstrap';
import { Afr, getSelectedAfr} from '../../redux/AfrSlice';
import { PostCommentRequest } from '../../redux/AfrReviewSlice';
import { postComment } from '../../redux/EventsSlice';
import enums from '../../utils/enums';


const AdminComment = function (props: any) {

    const dispatch = useAppDispatch();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);

    const [comment, setComment] = useState("");


    const handleEventClick = function (event: any) {

        if (currentAfr) {
            var action: string = event.target.name;
            var connector = currentAfr.afrId;
            switch (action) {
                case "save-comment":
                    // update Review Object in Redux
                    var commentReq: PostCommentRequest = {
                        comment: comment,
                        afrVersionId: connector,
                        role: enums.commentType.admin,
                    };
                    dispatch(postComment(commentReq));
                    setComment("");
                    break;
            }
        }

    }

    const isValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "save-comment":
                if (comment.length === 0) {
                    result = false;
                }
                break;
        }
        return result;
    }


    return (
        <div>
            <Row>
                <Col md="10">
                    <Card body>
                        <CardTitle><h4>Add new Comment:</h4></CardTitle>
                        <CardBody>
                            <Input type="textarea" value={comment} disabled={false} rows="10"
                                onChange={(e) => setComment(e.currentTarget.value)}
                                valid={isValid("save-comment")}
                            />
                            

                        </CardBody>
                        <Row>
                            <Col className="text-md-right">
                                <Button type="button" name="save-comment" disabled={(comment.length === 0)} onClick={handleEventClick}>Save Comment</Button>{"  "}
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </div>
    )

}

export default AdminComment;